import { Routes, Route, useLocation } from "react-router-dom";
import { Home, ProtectedRoute } from "./pages";
import { AdminLogin } from "components/common";
import GlobalStyle from "globalStyles";
import MyNft from "components/mynft";
import FooterComp from "components/homeCom/footer";
import MentingNft from "pages/mentingNft";
import Staking from "pages/staking";
import StakingPopupComp from "components/stakingComp/stakingPopup";
import Footershadow from "components/shadow/footershadow";
import { CommonUtility } from "utility/common";
import { useWalletConnectClient } from "services/walletServices";
import { elgNftAbi } from "utility/contract/elgNftAbi";
import environment from "environment";
import { stakingAbi } from "utility/contract/nftStakingAbi";
import { useEffect, useState } from "react";
function App() {
  const location = useLocation();
  const { web3Provider, account } = useWalletConnectClient();
  const [userBalance, setUserBalance] = useState(Number);
  const [userReward, setUserReward] = useState(null);
  const [staked, setStaked] = useState(Number);
  const [stakedDetail, setStakedDetail] = useState([]);
  const [userIds, setUserIds] = useState([]);
  function makeFourDigitNumber(num) {
    let numStr = num.toString(); // Convert number to string
    while (numStr.length < 4) {
      numStr = "0" + numStr; // Prepend zeros until it becomes 4 digits long
    }
    return numStr;
  }
  const getUserNfts = async () => {
    try {
      const contract = CommonUtility.contract(
        web3Provider,
        elgNftAbi,
        environment.ELG_NFT[environment.DEFAULT_CHAIN]
      );
      const balance = await contract.methods.balanceOf(account).call();
      console.log("BALANCE12", balance);
      let arr = [];
      if (+balance > 0) {
        console.log("INSIDE");
        for (let i = 0; i < +balance; i++) {
          console.log("INSIDE FOR");
          const id = await contract.methods
            .tokenOfOwnerByIndex(account, i)
            .call();
          console.log("IDDDDD", id);
          const ipfsData = await fetchData(id);
          console.log("ipfsData", ipfsData);
          const obj = {
            nftId: id,
            image: `https://gateway.pinata.cloud/ipfs/QmY59S3UQCeeFBLJoUDteASfr2m73fmFxdWr6HqQA18999/${id}.png`,
            title: "Elemental Legend",
            name1: "NFT ID",
            value1: `#${makeFourDigitNumber(id)}`,
            name2: "Name",
            value2: "Elemental Legends",
            btnText: "Stake",
            traits: `${ipfsData?.attributes[0].value}-${ipfsData?.attributes[1].value}-${ipfsData?.attributes[2].value}`,
            attributes: [
              {
                name: "NFT ID",
                value: `#${makeFourDigitNumber(id)}`,
              },
              {
                name: "Element",
                value: ipfsData?.attributes[0].value,
              },
              {
                name: "Trait",
                value: ipfsData?.attributes[1].value,
              },
              {
                name: "Equippable",
                value: ipfsData?.attributes[2].value,
              },
            ],
          };

          arr.push(obj);
        }
      }
      console.log("ARR", arr);
      setUserIds(arr);
      setUserBalance(balance);
    } catch (error) {}
  };
  const getClaimedReward = async () => {
    try {
      const contract = CommonUtility.contract(
        web3Provider,
        stakingAbi,
        environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN]
      );
      const rewards = await contract.methods
        .getUserRewardsClaimed(account)
        .call();
      console.log("rewards", rewards);
      setUserReward(rewards);
    } catch (error) {}
  };
  const getUserStaked = async () => {
    try {
      const contract = CommonUtility.contract(
        web3Provider,
        stakingAbi,
        environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN]
      );
      const info = await contract.methods.getUserAllStakings(account).call();
      console.log("info staking", info);
      setStaked(info.length);
      let arr = [];
      if (+info.length > 0) {
        console.log("INSIDE");
        for (let i = 0; i < +info?.length; i++) {
          const ipfsData = await fetchData(info[i].tokenId);
          console.log("ipfsData", ipfsData);
          console.log("INSIDE FOR");
          const obj = {
            nftId: info[i].tokenId,
            image: `https://gateway.pinata.cloud/ipfs/QmY59S3UQCeeFBLJoUDteASfr2m73fmFxdWr6HqQA18999/${info[i].tokenId}.png`,
            title: "Elemental Legend",
            name1: "NFT ID",
            value1: `#${makeFourDigitNumber(info[i].tokenId)}`,
            name2: "Name",
            value2: "Elemental Legends",
            btnText: "Unstake",
            unstakeTime: info[i].endTime,
            attributes: [
              {
                name: "NFT ID",
                value: `#${makeFourDigitNumber(info[i].tokenId)}`,
              },
              {
                name: "Element",
                value: ipfsData?.attributes[0].value,
              },
              {
                name: "Trait",
                value: ipfsData?.attributes[1].value,
              },
              {
                name: "Equippable",
                value: ipfsData?.attributes[2].value,
              },
            ],
          };
          arr.push(obj);
        }
      }
      setStakedDetail(arr);
      console.log("ARRinfo", arr);
    } catch (error) {}
  };

  async function fetchData(id) {
    try {
      const response = await fetch(
        `https://gateway.pinata.cloud/ipfs/QmX3kgVoeqF4wmyfTsZsHejnRaoNDaD3gwHNFppwDPC6f1/${id}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.status}`);
      }
      const data = await response.json();
      console.log("DATATA", data);
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  useEffect(() => {
    if (account && web3Provider) {
      getUserNfts();
      getUserStaked();
      getClaimedReward();
    }
  }, [account, web3Provider]);
  return (
    <div style={{ overflow: "hidden" }}>
      <GlobalStyle />
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mynft" element={<MyNft userIds={userIds} />} />
            <Route
              path="/minting-nft"
              element={<MentingNft getUserNfts={getUserNfts} />}
            />
            <Route
              path="/staking"
              element={
                <Staking
                  getUserNfts={getUserNfts}
                  getClaimedReward={getClaimedReward}
                  getUserStaked={getUserStaked}
                  userBalance={userBalance}
                  userReward={userReward}
                  staked={staked}
                  stakedDetail={stakedDetail}
                  userIds={userIds}
                />
              }
            />
            <Route
              path="/staking-popup"
              element={
                <StakingPopupComp
                  getUserNfts={getUserNfts}
                  getClaimedReward={getClaimedReward}
                  getUserStaked={getUserStaked}
                />
              }
            />

            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/protected-route" element={<ProtectedRoute />} />
            <Route path="/formik-form" element={<ProtectedRoute />} />
          </Routes>
        </div>
        {location.pathname === "/" ||
        location.pathname === "/staking" ||
        location.pathname === "/mynft" ? (
          <>
            <div
              style={{
                position: "relative",
                isolation: "isolate",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0%",
                  right: "0",
                  zIndex: -1,
                }}
              >
                <Footershadow />
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "0%",
                  left: "0",
                  zIndex: -1,
                }}
              >
                <Footershadow />
              </div>
              <FooterComp />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default App;
